import { useEffect, useState } from 'react';
import { AccessibilityInfo, Platform } from 'react-native';

function readReduceMotionEnabledSync(): boolean {
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  return false;
}

/**
 * Mirrors the OS / browser prefers-reduced-motion setting for dashboard loading UI.
 */
export function useReduceMotionEnabled(): boolean {
  const [enabled, setEnabled] = useState(readReduceMotionEnabledSync);

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const onChange = () => {
        setEnabled(mediaQuery.matches);
      };
      onChange();
      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', onChange);
        return () => {
          mediaQuery.removeEventListener('change', onChange);
        };
      }
      mediaQuery.addListener(onChange);
      return () => {
        mediaQuery.removeListener(onChange);
      };
    }

    if (Platform.OS === 'web') {
      return undefined;
    }

    AccessibilityInfo.isReduceMotionEnabled()
      .then(setEnabled)
      .catch(() => undefined);
    const subscription = AccessibilityInfo.addEventListener('reduceMotionChanged', setEnabled);
    return () => {
      subscription.remove();
    };
  }, []);

  return enabled;
}
